import type { HelpFile } from '../../types/help'
import { ErrorBannerTestIds } from '../../../testids/ErrorBannerTestIds'

export const errorBannerHelp: HelpFile = {
  docPage: '/docs/help-system/error-handling',
  texts: {
    [ErrorBannerTestIds.errorBanner]:
      'Die letzte Anfrage ist fehlgeschlagen — Banner aufklappen zeigt den Fehlercode, per Link geht es zum Fehlerlog-Eintrag.',
    [ErrorBannerTestIds.errorRetry]:
      'Fehlgeschlagene Anfrage erneut ausführen — hilfreich bei vorübergehenden Netzwerkproblemen oder kurzen Upstream-Ausfällen.',
  },
}
